<template lang="pug">

  transition(name="fade" appear)

    nav#header(v-if="show" aria-label="Header")
      
      hamburger-btn
      
      right-car-logo

      transition(
        @enter="enterReducedMotion"
        @leave="leaveReducedMotion" 
        appear
      )
        reduced-motion-btn(v-if="showReducedMotionBtn").reduced-motion-btn
      
      close-btn(
        @click="onCloseClick"
        :theme="closeBtnTheme"
        v-if="showContentCloseBtn"
      ).close-btn


</template>

<script>

import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES, PATHS, LOAD } from 'src/config/app'
import RightCarLogo from '@/components/header/RightCarLogo'
import HamburgerBtn from '@/components/header/HamburgerBtn'
import ReducedMotionBtn from '@/components/common/ReducedMotionBtn'
import CloseBtn from '@/components/common/CloseBtn'
import Env from '@/config/env'
import gsap from 'gsap'

export default {

  computed: {
    
    ...mapState('app', [
      'loading',
      'home', 
      'modal_state', 
      'motion_clamp'
    ]),

    show(){
      return (this.loading.state === LOAD.STATES.COMPLETE)
    },

    showContentCloseBtn(){
      return (this.$route.name !== PATHS.HOME && this.$route.name !== PATHS.LOADING) && !Env.ie
    },

    showReducedMotionBtn(){
      return !Env.ie && this.showReducedBtn
    },

    closeBtnTheme(){
      return Env.mobile ? 'white' : 'dark'
    }
  },

  data() {
    return {
      showReducedBtn: true
    }
  },

  components: {
    RightCarLogo,
    HamburgerBtn,
    CloseBtn,
    ReducedMotionBtn
  },

  methods: {
    onCloseClick(){
      this.$router.replace(PATHS.HOME)
    },

    enterReducedMotion(el, done){ 
      gsap.to( el, 1 * this.motion_clamp, { opacity : 1, delay: 1 * this.motion_clamp }) 
      done()
    },

    leaveReducedMotion(el, done){ 
      gsap.to( el, 0.5 * this.motion_clamp, { opacity : 0, onComplete: done }) 
    }
  },

  watch: {
    'home.current_section'(val){
      if(val.index > 0){
        this.showReducedBtn = false
      }
    }
  }
}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#header
  position: fixed
  left: 0rem
  top: 0rem
  width: 100%
  height: 20px
  z-index: 3
  padding: 6rem
  pointer-events: none

  .reduced-motion-btn
    right: 3.5rem
    top: 6rem
    position: absolute
    pointer-events: auto
    color: white
    opacity: 0.8
    font-size: 1rem
    text-transform: uppercase
    letter-spacing: 0.1em
    display: block
    border-bottom: 1px solid rgba(255,255,255,0.3)
    font-family: CondensedBold
    outline: none
    opacity: 0 


    @media all and (max-width: $bp-mobile)
      display: none

    &:hover,
    &:focus
      border-bottom: 1px solid white

  .close-btn
    right: 3.5rem
    top: 4.9rem
    position: absolute
    pointer-events: auto

    @media all and (max-width: $bp-mobile)
      left: 2rem
      top: 2.5rem


  @media all and (max-width: $bp-mobile)
    padding: 3.6rem 0 0 0


</style>
